import { render, staticRenderFns } from "./my-editor.vue?vue&type=template&id=32daf89b&scoped=true&"
import script from "./my-editor.vue?vue&type=script&lang=js&"
export * from "./my-editor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./my-editor.vue?vue&type=style&index=1&id=32daf89b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32daf89b",
  null
  
)

export default component.exports